import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { initMonitoring } from "@/lib/monitoring";
import { initAnalytics } from "@/lib/analytics";
import "./index.css";

initMonitoring();
void initAnalytics();

createRoot(document.getElementById("root")!).render(<App />);
